export const GET_DATA_DIVISIONS_RATE_WATCHER =
  "app/WidgetResponseRateReport/GET_DATA_DIVISIONS_RATE_WATCHER"
export const GET_DATA_DIVISIONS_RATE_SUCCESS =
  "app/WidgetResponseRateReport/GET_DATA_DIVISIONS_RATE_SUCCESS"
export const GET_DATA_DIVISIONS_RATE_FAILED =
  "app/WidgetResponseRateReport/GET_DATA_DIVISIONS_RATE_FAILED"
